import { HomeData } from '@library/store/homes/homes.interface';
import { createAction, props } from '@ngrx/store';
import { ScheduleCard, ScheduleVelux } from './schedules.interface';

export const LoadScheduleVelux = createAction(
  '[Schedule] Load schedule velux',
  props<{home_id: string}>(),
);

export const LoadScheduleVeluxSuccess = createAction(
  '[Schedule] Load schedule velux success',
  props<{homes: HomeData[]}>(),
);

export const LoadScheduleVeluxFailure = createAction(
  '[Schedule] Load schedule velux failure',
  props<{error: string}>(),
);

export const SetCurrentScheduleCard = createAction(
  '[Schedule] Set current schedule card',
  props<{card: ScheduleCard}>(),
);

export const SetScheduleCardData = createAction(
  '[Schedule] Set schedule card data',
  props<{data: ScheduleCard}>(),
);

export const SetScheduleCardDataSuccess = createAction(
  '[Schedule] Set schedule card data success',
);

export const SetScheduleCardDataFailure = createAction(
  '[Schedule] Set schedule card data failure',
);

export const CreateNewSchedule = createAction(
  '[Schedule] Create new schedule',
  props<{data: ScheduleVelux}>(),
);

export const CreateNewScheduleSuccess = createAction(
  '[Schedule] Create new schedule success',
  props<{data: ScheduleVelux}>(),
);

export const CreateNewScheduleFailure = createAction(
  '[Schedule] Create new schedule failure',
  props<{error: string}>(),
);

export const UpdateSchedule = createAction(
  '[Schedule] Update schedule',
  props<{data: ScheduleVelux}>(),
);

export const UpdateScheduleSuccess = createAction(
  '[Schedule] Update schedule success',
  props<{data: ScheduleVelux}>(),
);

export const UpdateScheduleFailure = createAction(
  '[Schedule] Update schedule failure',
  props<{error: string}>(),
);

export const DeleteSchedule = createAction(
  '[Schedule] Delete schedule',
  props<{data: ScheduleVelux}>(),
);

export const DeleteScheduleSuccess = createAction(
  '[Schedule] Delete schedule success',
  props<{data: ScheduleVelux}>(),
);

export const DeleteScheduleFailure = createAction(
  '[Schedule] Delete schedule failure',
  props<{error: string}>(),
);
